<div class="contact__hero mb-5"></div>
<main id="main" class="pb-5">
  <div class="container">
    <h1>Contact Us</h1>
    <div class="row">
      <div class="col-12 col-sm-8 col-md-6">
        <form
          #contactForm="ngForm"
          class="form-contact"
          (ngSubmit)="contactForm.form.valid && submitContactForm()"
          novalidate
        >
          <p>
            Please complete and submit this form. Read our
            <button
              type="button"
              class="btn btn-link p-0"
              (click)="openPrivacyModal()"
            >
              Privacy Policy</button
            >.
          </p>
          <div class="mb-3">
            <label class="form-label" for="inputName"
              >Name <span class="required-asterisk">*</span></label
            >
            <input
              type="text"
              id="inputName"
              name="name"
              class="form-control"
              placeholder="Name"
              autofocus
              [(ngModel)]="contactEmailDetails.name"
              required
              #name="ngModel"
              maxlength="200"
            />
            <div
              [hidden]="name.valid || name.pristine"
              class="alert alert-danger"
            >
              Your name is required
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label" for="inputOrganisation"
              >Organisation</label
            >
            <input
              type="text"
              id="inputOrganisation"
              name="organisation"
              class="form-control"
              placeholder="Organisation"
              autofocus
              maxlength="200"
              [(ngModel)]="contactEmailDetails.organisation"
              #organisation="ngModel"
            />
          </div>
          <div class="mb-3">
            <label class="form-label" for="inputEmailAddress"
              >Email Address <span class="required-asterisk">*</span></label
            >
            <input
              type="email"
              class="form-control"
              id="inputEmailAddress"
              required
              email
              placeholder="Enter your email address"
              [(ngModel)]="contactEmailDetails.emailAddress"
              name="emailAddress"
              #emailAddress="ngModel"
            />
            <div
              [hidden]="emailAddress.valid || emailAddress.pristine"
              class="alert alert-danger"
            >
              A valid email address is required
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label" for="inputMessage"
              >Message <span class="required-asterisk">*</span></label
            >
            <textarea
              rows="4"
              id="inputMessage"
              name="message"
              class="form-control"
              placeholder="Message"
              autofocus
              maxlength="2000"
              [(ngModel)]="contactEmailDetails.message"
              required
              #message="ngModel"
            >
            </textarea>
            <div
              [hidden]="message.valid || message.pristine"
              class="alert alert-danger"
            >
              A message is required
            </div>
          </div>
          <!-- ERROR -->
          <div>
            <api-error [apiError]="apiError"></api-error>
          </div>
          <!-- SUCCESS -->
          <div class="alert alert-primary" *ngIf="emailSentSuccess">
            Thanks for your enquiry. Your message has been sent to
            EuroGeographics' support team.
          </div>
          <button
            class="btn btn-secondary"
            type="submit"
            [disabled]="!contactForm.form.valid || emailSentSuccess"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  </div>
</main>
<app-footer></app-footer>
